/**
 * Identificador de versão discreto, fixo no canto inferior direito.
 * Valores injetados em build time (ver vite.config.ts → define):
 *   __APP_VERSION__ → versão do package.json
 *   __BUILD_ID__    → timestamp UTC do build (muda a cada build)
 *
 * `pointerEvents: none` garante que o badge nunca intercepta cliques da UI.
 */
const VersionBadge = () => {
    return (
        <span
            aria-hidden
            style={{
                position: 'fixed',
                bottom: 3,
                right: 6,
                zIndex: 9999,
                fontSize: 10,
                lineHeight: 1,
                fontFamily: 'monospace',
                color: 'rgba(130, 130, 130, 0.45)',
                pointerEvents: 'none',
                userSelect: 'none'
            }}
        >
            v{__APP_VERSION__} · {__BUILD_ID__}
        </span>
    );
};

export default VersionBadge;
